// extracted by mini-css-extract-plugin
export var bodySections = "_4x-8";
export var gray = "_4x-7";
export var green = "_4x-4";
export var iconContainer = "_4x-9";
export var iconWidgetContainer = "_4x-1";
export var phoneIcon = "_4x-2";
export var red = "_4x-5";
export var statusDot = "_4x-3";
export var widgetContainer = "_4x-0";
export var yellow = "_4x-6";